import { optionList, LEAD_STATUSES, CLIENT_STATUSES, SERVICE_CATEGORIES, PRICE_TYPES, PROJECT_TYPES, PROJECT_STATUSES, PRIORITIES, TASK_STATUSES } from "@/lib/format";

export const leadFields = (staff) => [
  { name: "name", label: "Nombre", required: true, minLength: 2 },
  { name: "company", label: "Empresa" },
  { name: "phone", label: "Teléfono", type: "tel" },
  { name: "email", label: "Correo", type: "email" },
  { name: "city", label: "Ciudad" },
  { name: "state", label: "Estado" },
  { name: "country", label: "País" },
  { name: "client_type", label: "Tipo de cliente", type: "select", options: optionList(["Persona", "Negocio", "Organización"]) },
  { name: "service_interest", label: "Servicio de interés" },
  { name: "source", label: "Fuente" },
  { name: "contact_date", label: "Fecha de contacto", type: "date" },
  { name: "next_followup", label: "Próximo seguimiento", type: "date" },
  { name: "responsible_id", label: "Responsable", type: "select", options: staff },
  { name: "status", label: "Estado", type: "select", options: optionList(LEAD_STATUSES), required: true, default: "Nuevo" },
];

export const clientFields = (staff, isAdmin) => [
  { name: "legal_name", label: "Nombre legal", required: true, minLength: 2 },
  { name: "trade_name", label: "Nombre comercial" },
  { name: "contact_name", label: "Persona de contacto" },
  { name: "email", label: "Correo", type: "email" },
  { name: "phone", label: "Teléfono", type: "tel" },
  { name: "address", label: "Dirección" },
  { name: "city", label: "Ciudad" },
  { name: "state", label: "Estado" },
  { name: "country", label: "País" },
  { name: "zip_code", label: "Código postal" },
  { name: "tax_id", label: "Identificación fiscal", help: "Dato sensible: solo visible para el equipo interno y el propio cliente." },
  { name: "start_date", label: "Fecha de inicio", type: "date" },
  { name: "language", label: "Idioma preferido del cliente", type: "select", default: "es", help: "Formularios y correos de proyecto web en este idioma.",
    options: [{ value: "es", label: "Español" }, { value: "en", label: "Inglés" }] },
  { name: "status", label: "Estado", type: "select", required: true, default: "Activo",
    options: optionList(isAdmin ? CLIENT_STATUSES : CLIENT_STATUSES.filter((s) => !["Cancelado", "Archivado"].includes(s))) },
  ...(isAdmin ? [{ name: "assigned_staff_ids", label: "Personal asignado", type: "multiselect", options: staff }] : []),
  { name: "internal_notes", label: "Notas internas", type: "textarea" },
];

export const serviceFields = [
  { name: "name", label: "Nombre", required: true, minLength: 2 },
  { name: "category", label: "Categoría", type: "select", options: optionList(SERVICE_CATEGORIES), required: true },
  { name: "description", label: "Descripción", type: "textarea" },
  { name: "price", label: "Precio (USD)", type: "number", min: 0, help: "Déjelo vacío para mostrar [PENDIENTE]" },
  { name: "price_type", label: "Tipo de precio", type: "select", options: optionList(PRICE_TYPES), required: true, default: "único" },
  { name: "periodicity", label: "Periodicidad" },
  { name: "estimated_time", label: "Tiempo estimado" },
  { name: "renewal_price", label: "Precio de renovación (USD)", type: "number", min: 0 },
  { name: "internal_cost", label: "Costo interno (solo administrador)", type: "number", min: 0 },
  { name: "requires_renewal", label: "Requiere renovación", type: "checkbox" },
  { name: "active", label: "Activo", type: "checkbox", default: true },
  { name: "included", label: "Servicios incluidos (separados por coma)", type: "tags" },
  { name: "not_included", label: "Servicios no incluidos (separados por coma)", type: "tags" },
  { name: "required_documents", label: "Documentos requeridos (Taxes, separados por coma)", type: "tags" },
  { name: "conditions", label: "Condiciones", type: "textarea" },
];

export const projectFields = (staff, clients, isAdmin) => [
  { name: "name", label: "Nombre", required: true, minLength: 3, disabled: !isAdmin },
  { name: "client_id", label: "Cliente", type: "select", options: clients, required: true, disabled: !isAdmin },
  { name: "type", label: "Tipo", type: "select", options: optionList(PROJECT_TYPES), required: true, default: "Página web", disabled: !isAdmin },
  { name: "status", label: "Estado", type: "select", required: true, default: "Nuevo",
    options: optionList(isAdmin ? PROJECT_STATUSES : PROJECT_STATUSES.filter((s) => !["Cancelado", "Cerrado"].includes(s))) },
  { name: "responsible_id", label: "Responsable", type: "select", options: staff, disabled: !isAdmin },
  { name: "priority", label: "Prioridad", type: "select", options: optionList(PRIORITIES), default: "Normal", disabled: !isAdmin },
  { name: "start_date", label: "Fecha de inicio", type: "date", disabled: !isAdmin },
  { name: "estimated_delivery", label: "Entrega estimada", type: "date", disabled: !isAdmin },
  { name: "actual_delivery", label: "Entrega real", type: "date" },
  { name: "progress", label: "Avance (%)", type: "number", min: 0 },
  ...(isAdmin ? [{ name: "budget", label: "Presupuesto interno (USD)", type: "number", min: 0 },
    { name: "price_sold", label: "Precio vendido (USD)", type: "number", min: 0 }] : []),
  { name: "collaborator_ids", label: "Colaboradores", type: "multiselect", options: staff },
  { name: "description", label: "Descripción", type: "textarea" },
  ...(isAdmin ? [{ name: "internal_notes", label: "Notas internas", type: "textarea" }] : []),
];

export const taskFields = (staff, projects) => [
  { name: "title", label: "Título", required: true, minLength: 2 },
  { name: "project_id", label: "Proyecto", type: "select", options: projects },
  { name: "assignee_id", label: "Responsable", type: "select", options: staff },
  { name: "priority", label: "Prioridad", type: "select", options: optionList(PRIORITIES), default: "Normal", required: true },
  { name: "status", label: "Estado", type: "select", options: optionList(TASK_STATUSES), default: "Pendiente", required: true },
  { name: "start_date", label: "Fecha de inicio", type: "date" },
  { name: "due_date", label: "Fecha de vencimiento", type: "date" },
  { name: "reminder_date", label: "Recordatorio", type: "date" },
  { name: "estimated_hours", label: "Tiempo estimado (h)", type: "number", min: 0 },
  { name: "used_hours", label: "Tiempo utilizado (h)", type: "number", min: 0 },
  { name: "visible_to_client", label: "Visible para el cliente (si no, solo interna)", type: "checkbox" },
  { name: "collaborator_ids", label: "Colaboradores", type: "multiselect", options: staff },
  { name: "tags", label: "Etiquetas (separadas por coma)", type: "tags" },
  { name: "description", label: "Descripción", type: "textarea" },
];
